import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import duobyte from '../../assets/duobyte.webp';
import logo from '../../assets/logo.webp';
import './Footer.css';

const Footer: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-main">
          <img src={logo} alt="StyroR Logo – Styropor Recycling Hamburg" className="footer-logo" width={1600} height={722} />
          <p className="footer-slogan">Styropor Recycling & EPS Entsorgung Hamburg</p>
        </div>
        <nav className="footer-nav">
          <Link to="/" className="footer-link" title="Styropor Recycling – Überblick">Überblick</Link>
          <Link to="/modell/" className="footer-link" title="Styropor Recycling – StyroR Vorteil">StyroR Vorteil</Link>
          <Link to="/kontakt/" className="footer-link" title="Kontakt – StyroR Styropor Recycling Hamburg">Kontakt</Link>
          <Link to="/impressum/" className="footer-link" title="Impressum – StyroR">Impressum</Link>
          <Link to="/datenschutz/" className="footer-link" title="Datenschutzerklärung – StyroR">Datenschutz</Link>
        </nav>
      </div>
      <div className="footer-bottom">
        <p className="footer-copyright">© {new Date().getFullYear()} StyroR – Alle Rechte vorbehalten</p>
        <div className="footer-credit">
          <span>Diese Seite wurde erstellt von</span>
          <a href="https://duobyte.dev" target="_blank" rel="noopener noreferrer" title="DuoByte – Webentwicklung" className="footer-duobyte">
            <img src={duobyte} alt="DuoByte Logo" loading="lazy" className="footer-duobyte-logo" width={491} height={134} />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;